import { combineReducers } from 'redux';

import own from './own';
import app from './app';
import member from './member';
import activity from './activity';
import game from './game';
import mall from './mall';
import happygo from './happygo';
import home from './home';
import pay from './pay';
import notice from './notice';
import service from './service';
import weiban from "./weiban"

const appReducer = combineReducers({
  app,
  own,
  member,
  activity,
  mall,
  game,
  happygo,
  home,
  pay,
  notice,
  service,
  weiban
});

export default function(state, action) {
  if (action.type === 'LAUNCH') {
    state = undefined;
  }

  return appReducer(state, action);
}
